import React from 'react';
import './sectionThree.scss';

const SectionThree = () => {
    // Inline SVGs matching the style and stroke width of the design
    const SearchIcon = () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF5A14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    );

    const DatabaseIcon = () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF5A14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
        </svg>
    );

    const ChartIcon = () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF5A14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"></line>
            <line x1="12" y1="20" x2="12" y2="4"></line>
            <line x1="6" y1="20" x2="6" y2="14"></line>
        </svg>
    );

    const LightbulbIcon = () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF5A14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18h6"></path>
            <path d="M10 22h4"></path>
            <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1.28.53 2.4 1.5 3.5.76.76 1.23 1.52 1.41 2.5"></path>
        </svg>
    );

    const PlayIcon = () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF5A14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polygon points="10 8 16 12 10 16 10 8" fill="#FF5A14" stroke="none"></polygon>
        </svg>
    );

    const capabilities = [
        { id: 1, icon: <SearchIcon />, title: 'UNDERSTAND', subtitle: 'Intent + business context' },
        { id: 2, icon: <DatabaseIcon />, title: 'RETRIEVE', subtitle: 'Connected data + permissions' },
        { id: 3, icon: <ChartIcon />, title: 'ANALYZE', subtitle: 'RCA + models + scenarios' },
        { id: 4, icon: <LightbulbIcon />, title: 'RECOMMEND', subtitle: 'Trade-offs + best action' },
        { id: 5, icon: <PlayIcon />, title: 'ACT + FOLLOW-UP', subtitle: 'Workflow + outcome tracking' },
    ];

    return (
        <div id='SectionThree' className='capability-flow-section'>
            <div className='section-container'>
                <div className='header-wrapper'>
                    <div className='subtitle-wrapper'>
                        <p className='subtitle'>THE CAPABILITY FLOW</p>
                    </div>
                    <h2 className='main-heading'>
                        Sense <span className='arrow'>→</span> Predict & Optimize <span className='arrow'>→</span> Control <span className='arrow'>→</span> Execute <span className='arrow'>→</span> AI-Assist.
                    </h2>
                </div>

                <div className='cards-container'>
                    {capabilities.map((item, index) => (
                        <div className='card' key={item.id}>
                            <div className='card-icon'>{item.icon}</div>
                            <h4 className='card-title'>{item.title}</h4>
                            <p className='card-subtitle'>{item.subtitle}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SectionThree;